import coordination from '@/locales/en/coordination/coordination.locales';

export default {
    ...coordination,
};
